<template>
  <div 
    class="jd-list-item d-flex align-items-center"
    :class="{ 'selected': isSelected, 'scouted': isScoutedJd }"
    @click="handleClick"
  >
    <!-- Scout Status Badge -->
    <div class="scout-status-container me-3" v-if="isScoutedJd">
        <button 
          class="scouted-btn" 
          :class="{ 'scouted-btn-expired': isScoutedExpired }"
          disabled 
          v-html="scoutedButtonText"
        >
        </button>
    </div>

    <!-- Job Title -->
    <div class="flex-grow-1" style="min-width: 0;">
      <div class="d-flex align-items-center" style="min-width: 0;">
        <h3 class="job-title mb-0">{{ jd.job_title }}</h3>
      </div>
    </div>

    <!-- Selection Radio -->
    <div class="selection-container ms-3">
      <div class="custom-radio-circle" :class="{ checked: isSelected }">
        <span
          v-if="!isSelected"
          class="custom-radio-label"
        >
          選択
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JDListItem',
  props: {
    jd: {
      type: Object,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    profile: {
      type: Object,
      default: () => ({})
    },
    isSubmitting: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isScoutedJd() {
      if (!this.profile || !this.profile.scouted_jobs) return false;
      const { scouted_jobs } = this.profile;
      return scouted_jobs.some((jobDetails) => jobDetails.job === this.jd._id);
    },
    scoutedJobStatus() {
      if (!this.profile || !this.profile.scouted_jobs) return null;
      const scoutedJob = this.profile.scouted_jobs.find(
        (jobDetails) => jobDetails.job === this.jd._id
      );
      return scoutedJob ? scoutedJob.status : null;
    },
    isScoutedExpired() {
      return this.scoutedJobStatus === 'expired';
    },
    scoutedButtonText() {
      if (this.isScoutedExpired) {
        return 'スカウト希望<br>期間終了';
      }
      return 'スカウト希望中';
    },
  },
  methods: {
    handleClick(event) {
      // If clicking the selection container (radio), toggle selection
      // If clicking elsewhere, emit open info
      
      // However, the requirement says:
      // Clicking the selected radio button deselects the job
      // Clicking anywhere other than the radio button opens the job details
      
      const isRadioClick = event.target.closest('.selection-container');
      
      if (isRadioClick) {
        if (!this.isSubmitting) {
            // Highlighting logic handled by parent via event
            // If already selected, we want to deselect.
            // But wait, standard radio behavior is "select if clicked". 
            // The user said "Clicking the selected radio button deselects the job" -> Toggle behavior
            this.$emit('toggle-select', this.jd);
        }
      } else {
        this.$emit('open-info', this.jd);
      }
    }
  }
};
</script>

<style scoped>
.jd-list-item {
  border: 1px solid #c4c4c4;
  border-radius: 10px;
  padding: 10px 20px;
  background-color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 49px;
}

.jd-list-item.selected {
  border-color: #2F80ED; /* Blue highlight */
  background-color: #eff6ff; /* Light blue bg */
}

/* Scout badge styles from JDRow */
.scouted-btn {
  height: 31px;
  width: 119px;
  border-radius: 30px !important;
  font-weight: bold;
  text-align: center;
  font-size: 10px;
  padding: 0 10px;
  white-space: normal; /* Allow wrap for <br> */
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #E0F2F1;
  color: #14B8A6;
  border: 1px solid #14B8A6;
}

.scouted-btn-expired {
  background-color: #E0E0E0;
  color: #757575;
  border-color: #BDBDBD;
}

.job-title {
  font-size: 14px;
  font-weight: bold;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
}

/* Custom Radio Circle */
.custom-radio-circle {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid #ccc;
  position: relative;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 7px;
  color: #444;
  background-color: #fff;
}

.selected .custom-radio-circle {
  border-color: #2F80ED;
  background-color: #2F80ED; /* Blue background */
}

.selected .custom-radio-circle::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 10px; /* Smaller white hole */
  height: 10px;
  background-color: #fff; /* White hole */
  border-radius: 50%;
}
</style>
